import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By default, the iOS SDK will make a best effort to avoid capturing password, credit card, OTP, and any other fields related to Personally Identifiable Information (PII).`}</p>
    <p>{`If there are other elements of the view hierarchy that you don't want to be captured, you can add an `}<inlineCode parentName="p">{`accessibilityLabel`}</inlineCode>{` or `}<inlineCode parentName="p">{`accessibilityIdentifier`}</inlineCode>{` of  `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// This view will be excluded from autocapture
let view = UIView()
view.accessibilityLabel = "ph-no-capture"
`}</code></pre>
    <p>{`These elements will be ignored or masked in product analytics.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      